export const DOCUMENT_COMPOSITIONS = Object.freeze({
  TECHNICAL: 'technical-report',
  REGISTER: 'register',
  COMMERCIAL: 'commercial',
  INTERNAL: 'internal',
});

const presets = Object.freeze({
  [DOCUMENT_COMPOSITIONS.TECHNICAL]: Object.freeze({
    id: DOCUMENT_COMPOSITIONS.TECHNICAL,
    label: 'Document technique',
    orientation: 'portrait',
    cover: true,
  }),
  [DOCUMENT_COMPOSITIONS.REGISTER]: Object.freeze({
    id: DOCUMENT_COMPOSITIONS.REGISTER,
    label: 'Registre documentaire',
    orientation: 'landscape',
    cover: false,
  }),
  [DOCUMENT_COMPOSITIONS.COMMERCIAL]: Object.freeze({
    id: DOCUMENT_COMPOSITIONS.COMMERCIAL,
    label: 'Document commercial',
    orientation: 'portrait',
    cover: false,
  }),
  [DOCUMENT_COMPOSITIONS.INTERNAL]: Object.freeze({
    id: DOCUMENT_COMPOSITIONS.INTERNAL,
    label: 'Document interne',
    orientation: 'portrait',
    cover: false,
  }),
});

export const getDocumentComposition = (value = DOCUMENT_COMPOSITIONS.TECHNICAL) => (
  presets[value] || presets[DOCUMENT_COMPOSITIONS.TECHNICAL]
);

export const documentCompositionPresets = presets;
